var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPlungerLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M13.182,19.133H7.327c-0.297,0-0.537-0.24-0.537-0.537V16.96c0-0.297,0.24-0.537,0.537-0.537h5.855c0.297,0,0.537,0.24,0.537,0.537 v1.636C13.719,18.893,13.478,19.133,13.182,19.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M11.395,16.423H9.114c-0.536,0-0.971-0.435-0.971-0.971V9.715c0-0.536,0.435-0.971,0.971-0.971h2.281 c0.536,0,0.971,0.435,0.971,0.971v5.737C12.366,15.988,11.931,16.423,11.395,16.423z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10.776,8.744H9.733c-0.536,0-0.971-0.435-0.971-0.971v-4.03c0-0.536,0.435-0.971,0.971-0.971h1.043 c0.536,0,0.971,0.435,0.971,0.971v4.03C11.747,8.309,11.312,8.744,10.776,8.744z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M9.32,2.87V1.08c0-0.16,0.13-0.29,0.29-0.29h1.29c0.16,0,0.29,0.13,0.29,0.29v1.79"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPlungerLift);
export default __webpack_public_path__ + "static/media/light-plunger-lift.888f9c89e813babce22737efef22ca4b.svg";
export { ForwardRef as ReactComponent };